import { h } from 'vue';
var script = {
  props: {
    progress: {
      type: Number,
      required: true
    }
  },
  render() {
    const style = {
      width: `${this.progress}%`
    };
    return h('div', {
      class: 'slice'
    }, [h('div', {
      class: 'progress',
      style
    })]);
  }
};
export { script as default };